var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _polygon, _polygon2, _path18, _polygon3, _path19, _path20, _path21, _circle2, _path22, _circle3, _circle4, _path23, _polygon4, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 676.65833,
    height: 577.34774,
    viewBox: "0 0 676.65833 577.34774",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a24dc8e0-63f3-4c57-9da7-8d00cfa1aebe-234",
    "data-name": "Path 438",
    d: "M576.714,689.7237a24.21461,24.21461,0,0,0,23.38269-4.11876c8.18977-6.87442,10.758-18.196,12.8467-28.68192l6.17973-31.01657-12.9377,8.90837c-9.30465,6.40641-18.81826,13.01866-25.26011,22.29785s-9.25223,21.94708-4.07792,31.988",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bc8b2ee0-9ec2-4139-a7e3-e0b1b1382397-235",
    "data-name": "Path 439",
    d: "M578.7117,729.43427c-1.62839-11.86369-3.30382-23.88079-2.15884-35.87168,1.01467-10.64932,4.26373-21.0488,10.87831-29.57938a49.20606,49.20606,0,0,1,12.62466-11.44038c1.26215-.79648,2.42409,1.20354,1.16733,1.997A46.77942,46.77942,0,0,0,582.7187,676.8654c-4.02857,10.24607-4.67545,21.41582-3.98154,32.3003.41944,6.58218,1.31074,13.12121,2.20588,19.65251a1.19817,1.19817,0,0,1-.808,1.42251,1.16348,1.16348,0,0,1-1.42253-.808Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a6bcb68f-fec1-4497-88cc-56de52c10faf-236",
    "data-name": "Path 442",
    d: "M590.43273,710.39781a17.82511,17.82511,0,0,0,15.53141,8.01862c7.8644-.37318,14.41806-5.85972,20.31713-11.07027l17.452-15.4088-11.54987-.5528c-8.30619-.39784-16.82672-.771-24.73813,1.79338s-15.20758,8.72638-16.654,16.9154",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "a1650e23-bf32-4c95-848c-aacb59e17a01-237",
    "data-name": "Path 443",
    d: "M574.10872,736.254c7.83972-13.87142,16.93234-29.28794,33.1808-34.21551a37.02589,37.02589,0,0,1,13.95545-1.44105c1.48189.128,1.11179,2.41174-.367,2.28454a34.39826,34.39826,0,0,0-22.27164,5.89214c-6.27994,4.27454-11.16975,10.21756-15.30781,16.51907-2.53511,3.86051-4.80576,7.88445-7.07642,11.903C575.49654,738.48066,573.37471,737.55312,574.10872,736.254Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M834.3331,568.1169H261.67083V161.32613H834.3331Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,328.40241a5.57978,5.57978,0,0,0,0,11.15956H501.70843a5.57979,5.57979,0,0,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,361.88106a5.57979,5.57979,0,1,0-.02353,11.15956H501.85128a5.57978,5.57978,0,1,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,394.88106a5.57979,5.57979,0,1,0-.02353,11.15956h43.55577a5.57978,5.57978,0,1,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M834.3331,568.1169H261.67083V161.32613H834.3331Zm-563.24864-9.41363h553.835V170.73976h-553.835Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e5e5e5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M654.14325,478.73228a10.03692,10.03692,0,0,0-.04234,20.07379h95.83757a10.0369,10.0369,0,1,0,0-20.07379Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M654.14325,357.18463a10.03692,10.03692,0,0,0-.04234,20.07379h95.83757a10.0369,10.0369,0,1,0,0-20.07379Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,483.38106a5.57979,5.57979,0,1,0-.02353,11.15956H501.85128a5.57978,5.57978,0,1,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,516.38106a5.57979,5.57979,0,1,0-.02353,11.15956h43.55577a5.57978,5.57978,0,1,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,449.90241a5.57978,5.57978,0,0,0,0,11.15956H501.70843a5.57979,5.57979,0,0,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,206.90241a5.57978,5.57978,0,0,0,0,11.15956H501.70843a5.57979,5.57979,0,0,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,240.38106a5.57979,5.57979,0,1,0-.02353,11.15956H501.85128a5.57978,5.57978,0,1,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M308.319,273.38106a5.57979,5.57979,0,1,0-.02353,11.15956h43.55577a5.57978,5.57978,0,1,0,0-11.15956Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M654.14325,235.73228a10.03692,10.03692,0,0,0-.04234,20.07379h95.83757a10.0369,10.0369,0,1,0,0-20.07379Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#e4e4e4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 412.66227,
    cy: 84.34774,
    r: 18,
    fill: "#cacaca"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M705.79333,371.574a9.97765,9.97765,0,0,0,10.27632,11.3346l9.55853,20.70035,13.99627-2.74057L725.71538,371.825a10.03173,10.03173,0,0,0-19.92205-.25107Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#ffb6b6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "540.954 288.584 501.954 269.293 474.434 222.586 455.198 231.891 480.162 285.848 543.226 322.253 540.954 288.584",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "452.907 564.696 440.647 564.695 434.814 529.347 452.909 529.348 452.907 564.696",
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M717.70442,737.9058l-39.53077-.00147v-.5a15.38731,15.38731,0,0,1,15.38648-15.38623h.001l24.144.001Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "575.282 542.21 566.728 550.992 537.336 530.508 549.961 517.546 575.282 542.21",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M847.64779,709.58775l-27.582,28.318-.35819-.34886a15.38729,15.38729,0,0,1-.28711-21.75769l.00068-.0007,16.84623-17.29565Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M729.73468,515.65207h-8.47936l0,0a236.91236,236.91236,0,0,0-49.42272,83.37115L661.70318,628.682l36.10213,75.59,22.52779.40187-25.748-80.25184,25.94027-34.4,1.30776,69.15187,83.49213,43.76321,16.71006-24.6851-67.94-37.15,11.57-58.81995s23.2789-19.41188,9.72338-49.76Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M841.3331,438.67387,806.09749,423.2416,767.31532,440.427s-10.98222,6.2469-3.98222,22.2469l-42.07778,52.9782s.07778.0218,52.9599,16.86993l47.71093-42.01618a58.74345,58.74345,0,0,0,19.407-51.83192Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.74888,
    cy: 236.89892,
    r: 24.56103,
    fill: "#ffb6b6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M867.22776,365.63151c-5.63671-4.58572-14.37921-5.587-20.19831-1.23521-10.14917-5.3269-23.86487-2.54823-31.14037,6.30878-2.61816,3.18714-4.47305,7.49893-3.17756,11.41475,1.29549,3.91576,6.8819,6.21772,9.7939,3.29669l-.05192,1.20334a19.49485,19.49485,0,0,1-12.1204,33.19831q12.07284,4.877,24.14539,9.754c3.38659,1.36806,6.88109,2.7578,10.53325,2.73911s7.54514-1.79319,8.96241-5.15925q1.52858,4.6851,3.05687,9.37027a154.226,154.226,0,0,0,14.71518-30.33694c2.43658-6.84569,4.40646-14.00465,4.14333-21.26636C875.62641,377.65739,872.86446,370.21723,867.22776,365.63151Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 412.66227,
    cy: 327.34774,
    r: 18,
    fill: "#cacaca"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 468.66227,
    cy: 205.89538,
    r: 18,
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M730.79333,361.574a9.97765,9.97765,0,0,0,10.27632,11.3346l9.55853,20.70035,13.99627-2.74057L750.71538,361.825a10.03173,10.03173,0,0,0-19.92205-.25107Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#ffb6b6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "565.954 278.584 526.954 259.293 499.434 212.586 480.198 221.891 505.162 275.848 568.226 312.253 565.954 278.584",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M937.32917,738.67387h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-261.67083 -161.32613)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.166177227493d5bae13870dca8add184.svg";
export { ForwardRef as ReactComponent };